import { type FC } from 'react';
import { toShortNumFormat } from '@common/lib/toShortNumFormat';
import { type UserInviteFriendType } from '@common/types/query/user';
import {
  StringMain,
  StringSmall,
  StringXSmall,
} from '@components/Typography/Typography';
import { Avatar } from '@components/ui/Avatar/Avatar';
import cn from 'classnames';

import css from './styles.module.scss';

const FriendDataRow: FC<UserInviteFriendType> = ({
  firstName,
  lastName,
  photoUrl,
  level,
  totalCash,
  totalDices,
}) => {
  const fullname = `${firstName} ${lastName}`;

  return (
    <div className={cn(css.friendDataRow, css.columnTemplate)}>
      <div className="flex items-center gap-2">
        <Avatar size={32} jpg={photoUrl} />
        <div className="flex flex-col gap-1">
          <StringMain weight="regular" className="crop-long-text">
            {fullname}
          </StringMain>
          <StringXSmall
            weight="regular"
            className="text-white/40"
          >{`Level ${level}`}</StringXSmall>
        </div>
      </div>
      <StringSmall
        weight="bold"
        className="!text-[14px] self-center text-right"
      >
        {toShortNumFormat(totalCash)}
      </StringSmall>
      <StringSmall
        weight="bold"
        className="!text-[14px] self-center text-right"
      >
        {toShortNumFormat(totalDices || 0)}
      </StringSmall>
    </div>
  );
};

export { FriendDataRow };
